import { useEffect, ReactNode } from 'react';
import { useAuthStore } from '@/stores/auth.store';
import { authService } from '@/services';
import { applyUserPreferences } from '@/lib/user-preferences';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps): JSX.Element {
  const initialize = useAuthStore((state) => state.initialize);
  const user = useAuthStore((state) => state.user);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const updateUser = useAuthStore((state) => state.updateUser);

  useEffect(() => {
    initialize();
  }, [initialize]);

  // Aplicar preferencias del usuario en caché (p. ej. mientras llega el refetch)
  useEffect(() => {
    if (user?.preferredLanguage || user?.preferredCurrency) {
      applyUserPreferences(user.preferredLanguage, user.preferredCurrency);
    }
  }, [user?.id, user?.preferredLanguage, user?.preferredCurrency]);

  // Con sesión, refetch del perfil para tener idioma y moneda guardados en servidor
  useEffect(() => {
    if (!isAuthenticated) return;
    let cancelled = false;
    authService
      .getProfile()
      .then(async (profile) => {
        if (cancelled) return;
        updateUser(profile);
        await applyUserPreferences(profile.preferredLanguage, profile.preferredCurrency);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, updateUser]);

  return <>{children}</>;
}
